import * as React from "react";
import {Button, Checkbox, FormControlLabel, FormGroup, Grid, Switch, TextField} from "@material-ui/core";
import {API} from "aws-amplify";
import JsonRenderComponent from "../../../../utils/JsonRenderComponent";
import {Alert} from "@material-ui/lab";
import {LoadingSpinner} from "../../../../utils/LoadingSpinner";
import {
    addMedToPacketsDefault,
    IAddMedToPacketsRequest,
    IPrescriptionlessDrugData
} from "./request/AddMedToPacketsRequest";
import { AMAZON_ID } from "../../../../consts/Patterns";
interface IProps {
    data?: any
}

interface IState {
    errorMessage: string
    isJsonInput: boolean
    isLoading: boolean
    isOTC: boolean
    jsonInput: string
    prescriptionlessDrugData: IPrescriptionlessDrugData
    request: IAddMedToPacketsRequest
    response: any
}

enum InputField {
    CONTRACT_ID,
    DRUG_ID,
    ITEM_MANIPULATION_ENTITY_ACTION,
    PROGRAM_NAME,
    VERSION,
    FPASIN,
    QUANTITY_PER_DOSE,
    QUANTITY_PER_DAY,
}

interface IManipulateEnrollmentPortalResponse {
    contractId: string
    contractVersion: string
    result: string
}

class AddMedToPacketsSection extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            errorMessage: '',
            isJsonInput: false,
            isLoading: false,
            isOTC: false,
            jsonInput: addMedToPacketsDefault,
            prescriptionlessDrugData: {} as IPrescriptionlessDrugData,
            request: {} as IAddMedToPacketsRequest,
            response: ''
        };

        this.toggleJsonInput = this.toggleJsonInput.bind(this);
        this.toggleOTCInput = this.toggleOTCInput.bind(this);
        this.setRequest = this.setRequest.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
    }

    public render() {
        return(
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Alert variant="filled" severity="info">
                    Please make sure a customer has a new Packets eligible medication before running this.
                </Alert>

                <Grid item xs>
                    <FormGroup>
                        <FormControlLabel control={ <Switch onChange={ this.toggleJsonInput }/> } label="Toggle Json Input" />
                    </FormGroup>
                </Grid>


                { !this.state.isJsonInput &&
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        spacing={3}
                    >
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Contract Id (Required)"
                                variant="outlined"
                                value={ this.state.request.contractId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.CONTRACT_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Contract Version (Required)"
                                variant="outlined"
                                value={ this.state.request.version || ''}
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.VERSION, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Drug Id (Required)"
                                variant="outlined"
                                value={ this.state.request.drugId || ''}
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.DRUG_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <FormControlLabel
                                control={<Checkbox checked={this.state.isOTC} />}
                                label="Is OTC Drug"
                                onChange={this.toggleOTCInput}
                            />
                        </Grid>
                        { this.state.isOTC &&
                            <Grid container
                                  direction="column"
                                  justify="center"
                                  alignItems="center"
                                  spacing={3}>
                                <Grid item xs>
                                    <TextField
                                        style={{width: 400}}
                                        label="Fulfillable Product Asin (Required)"
                                        variant="outlined"
                                        value={ this.state.prescriptionlessDrugData.fulfillableProductAsin || ''}
                                        onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setOTCRequestFields(InputField.FPASIN, event) }
                                    />
                                </Grid>
                                <Grid item xs>
                                    <TextField
                                        style={{width: 400}}
                                        label="Quantity per Dose (Optional)"
                                        variant="outlined"
                                        value={ this.state.prescriptionlessDrugData.quantityPerDose || ''}
                                        onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setOTCRequestFields(InputField.QUANTITY_PER_DOSE, event) }
                                    />
                                </Grid>
                                <Grid item xs>
                                    <TextField
                                        style={{width: 400, paddingBottom: '10px'}}
                                        label="Quantity per Day (Optional)"
                                        variant="outlined"
                                        value={ this.state.prescriptionlessDrugData.quantityPerDay || ''}
                                        onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setOTCRequestFields(InputField.QUANTITY_PER_DAY, event) }
                                    />
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                }

                { this.state.isJsonInput &&
                    <Grid item xs>
                        <TextField
                            multiline
                            rows={ 8 }
                            label="Add Med To Packets Request"
                            variant="filled"
                            value={ this.state.jsonInput }
                            onChange={ this.setRequest }
                            style={{ width: 800 }}
                        />
                    </Grid>
                }

                <Grid item xs>
                    <Button variant="outlined" color="default" onClick={ this.handleSubmit }>
                        Submit
                    </Button>
                </Grid>

                { this.state.isLoading && <LoadingSpinner/> }

                { this.state.errorMessage &&
                    <Alert variant="filled" severity="info">
                        Error encountered: { this.state.errorMessage }
                    </Alert>
                }

                { this.state.response &&
                    <div>
                        <br/>
                        <h4>Status</h4>
                        <div style={{
                            border: '3px solid lightgray',
                            padding: '5px',
                            whiteSpace: "pre-wrap",
                            wordBreak: "normal",
                            wordWrap: "break-word"
                        }}>
                            <JsonRenderComponent jsonObject={ this.state.response } printHtml={ false }/>
                        </div>
                    </div>
                }
            </Grid>
        );
    }

    private toggleJsonInput() {
        this.setState({ isJsonInput: !this.state.isJsonInput });
    }

    private toggleOTCInput(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ isOTC: !this.state.isOTC });
    }

    private handleValidation() {
        let formIsValid = true;
        if (!this.state.request.contractId) {
            alert('Please enter the contract id');
            formIsValid = false
        } else if (!this.state.request.contractId.match(AMAZON_ID)) {
            alert('Please enter the valid contract id.');
            formIsValid = false
        }
        if (!this.state.request.version) {
            alert('Please enter the version');
            formIsValid = false
        }
        if (!this.state.request.drugId) {
            alert('Please enter the drugId');
            formIsValid = false
        }
        if (this.state.isOTC && !this.state.prescriptionlessDrugData.fulfillableProductAsin) {
            alert('Please enter the fulfillableProductAsin for OTC');
            formIsValid = false
        }
        return formIsValid;
    }

    private setRequestFields(field: InputField, event: React.ChangeEvent<HTMLTextAreaElement>) {
        const updatedRequest: IAddMedToPacketsRequest = this.state.request;

        switch (field) {
            case InputField.CONTRACT_ID: {
                updatedRequest.contractId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.VERSION: {
                updatedRequest.version = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.DRUG_ID: {
                updatedRequest.drugId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            default: {
                break;
            }
        }
    }

    private setOTCRequestFields(field: InputField, event: React.ChangeEvent<HTMLTextAreaElement>) {
        const updatedData = this.state.prescriptionlessDrugData;

        switch (field) {
            case InputField.FPASIN: {
                updatedData.fulfillableProductAsin = event.target.value;
                break;
            }
            case InputField.QUANTITY_PER_DAY: {
                updatedData.quantityPerDay = event.target.value;
                break;
            }
            case InputField.QUANTITY_PER_DOSE: {
                updatedData.quantityPerDose = event.target.value;
                break;
            }
            default: {
                break;
            }
        }
        this.setState({ prescriptionlessDrugData: updatedData });
    }

    private setRequest(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ jsonInput: event.target.value });
    }

    private handleSubmit() {
        this.setState({ isLoading: true });
        this.setState({ errorMessage: '' });

        const body = this.createRequestBody();

        if (this.handleValidation()) {
            const config = {
                body: body,
                headers: {}
            }
            this.callAddMedToPackets(config);
        }
        this.setState({ isLoading: false });
    }

    private callAddMedToPackets(config: any) {
        const apiName = 'ApaqPortalAPI';
        const path = '/pharmacy-customer/manipulate-program-enrollment';

        console.log(config)
        API.post(apiName, path, config).then((getResponse: IManipulateEnrollmentPortalResponse) => {
            if (this.state.isOTC) {
                this.callActivateApi(getResponse.contractVersion);
            } else {
                this.setState({ response: getResponse });
                this.setState({ errorMessage: ''});
            }
        }).catch((error) => {
            console.log(error);
            this.setState({ response: ''})
            this.setState({ errorMessage: error.response.data.message });
        });
    }

    private createRequestBody() {
        const body = {
            contractId: this.state.request.contractId,
            drugId: this.state.request.drugId,
            itemManipulationEntityAction: "ADD",
            programName: "AP_PILLPACK",
            version: this.state.request.version
        };

        if (this.state.isOTC) {
            return {
                ...body,
                enrollmentOptions: {
                    prescriptionlessDrugData: this.state.prescriptionlessDrugData
                },
                signed: false
            }
        }

        return body;
    }

    private callActivateApi(contractVersion: string) {
        const apiName = 'ApaqPortalAPI';
        const path = '/pharmacy-customer/activate-program-enrollment';

        const config = {
            body: {
                contractId: this.state.request.contractId,
                version: contractVersion,
                programName: "AP_PILLPACK"
            },
            headers: {}
        }

        API.post(apiName, path, config).then((getResponse: any) => {
            this.setState({ response: getResponse });
            this.setState({ errorMessage: ''})
        }).catch((error) => {
            console.log(error);
            this.setState({ response: ''})
            this.setState({ errorMessage: error.response.data.message });
        });
    }
}

export default AddMedToPacketsSection;
